<template>
  <div class="card-list" ref="content">
    <center>
      <a-progress type="circle" :percent="percent" v-if="percent!=100" style="margin-top:100px"/>
    </center>
    <a-list
      :grid="{gutter: 24, lg: 3, md: 2, sm: 1, xs: 1}"
      :dataSource="dataSource"
    >
      <a-list-item id="id1" slot="renderItem" slot-scope="item">
        <template v-if="item === null">
          <a-button class="new-btn" type="dashed" @click="$refs.modal.add()">
            <a-icon type="plus"/>
            新建项目
          </a-button>
        </template>
        <template v-else>
          <a-card :hoverable="true">
            <a-card-meta @click="toProject(item.itemId)">
              <div style="margin-bottom: 3px" slot="title">{{ item.title }}（编号：{{ item.itemId }}）</div>
              <a-avatar class="card-avatar" slot="avatar" :src="item.avatar" size="large"/>
              <div class="meta-content" slot="description">创建用户：{{ item.userName }}<br/>项目描述：{{ item.description }} <br>创建时间：{{ item.create_at }}</div>
            </a-card-meta>
            <!-- <template class="ant-card-actions" slot="actions">
              <a @click="handleEdit(item)" v-if="canEdit(item)" class="able">编缉</a>
              <a v-else class="disable">编缉</a>
              <a @click="handleDelete(item)" v-if="canEdit(item)" class="able">删除</a>
              <a v-else class="disable">删除</a>
            </template> -->
          </a-card>
        </template>
      </a-list-item>
    </a-list>
    <project-modal ref="modal" @item_changed="handleChange"/>
  </div>
</template>

<script>
import { getItemList, deleteItem } from '@/api/item'
import ProjectModal from './modules/ProjectModal'
import { formatDate } from '@/utils/util'
import { mapActions } from 'vuex'
import { setTimeout } from 'timers'

export default {
  name: 'CardList',
  components: {
    ProjectModal
  },
  data () {
    return {
      dataSource: [],
      percent: 0,
      loading: false
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions(['ToProject']),
    canEdit (item) {
      const user = this.$store.getters.userInfo
      var x = !!(user.uid == item.userId ||
              user.role_id == 0 ||
              user.role_id == 1)
      return x
    },
    loadData () {
      this.loading = true
      const _this = this
      this.percent = 10
      function time () {
        setTimeout(() => {
          if (_this.percent < 99) _this.percent += 1
          if (_this.loading) time()
        }, 50)
      }
      time()

      getItemList()
        .then(res => {
          _this.percent = 99
          setTimeout(() => {
            _this.dataSource.push(null)
            const x = this.dataSource
            res.data.map(item => {
              x.push({
                title: item.item_name,
                avatar: 'https://cdn6.haitou.cc/university/2.png',
                description: item.item_des,
                create_at: item.create_at,
                itemId: item.item_id,
                userId: item.create_uid,
                userName: item.user_name,
                originData: item
              })
            })
            _this.loading = false
            _this.percent = 100
          }, 100)
        })
    },
    handleEdit (item) {
      this.$refs.modal.edit(item)
    },
    handleChange (item) {
      this.dataSource = []
      this.loadData()
    },
    toProject (projectId) {
      const params = {
        pageName: 'projecthome',
        projectId: projectId
      }
      this.ToProject(params)
    },
    handleDelete (item) {
      const _this = this
      const project_id = item.originData.item_id

      _this.$confirm({
        title: '真的要删除项目“' + item.originData.item_name + '”吗？',
        content: '单击确定删除',
        onOk () {
          deleteItem(project_id).then(res => {
            _this.$message.success('删除成功')
            for (let n = 1; n < _this.dataSource.length; n++) {
              if (_this.dataSource[n].originData.item_id == project_id) {
                _this.dataSource.splice(n, 1)
                break
              }
            }
          }).catch(() => {
            _this.$message.error('删除失败')
            reject()
          })
        },
        onCancel () {}
      })
    }
  }

}
</script>

<style lang="less" scoped>

  .card-avatar {
    width: 48px;
    height: 48px;
    border-radius: 48px;
  }

  .ant-card-actions {
    background: #f7f9fa;
    li {
      float: left;
      text-align: center;
      margin: 12px 0;
      color: rgba(0, 0, 0, 0.45);
      width: 50%;

      &:not(:last-child) {
        border-right: 1px solid #e8e8e8;
      }

      .able {
        color: rgba(0, 0, 0, .45);
        line-height: 22px;
        display: inline-block;
        width: 100%;
        &:hover {
          color: #1890ff;
        }
      }

      .disable{
        color: rgba(0, 0, 0, .2);
        line-height: 22px;
        display: inline-block;
        width: 100%;
      }
    }
  }

  .new-btn {
    background-color: #fff;
    border-radius: 2px;
    width: 100%;
    height: 141px;
  }

  .meta-content {
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    height: 64px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
</style>
